import React, { useState, useEffect } from "react";
import { HTTP } from "../../api/http-common";
import { useNavigate, Link } from "react-router-dom";
import { isValidEmail } from '../../component/common';
import { Eye, EyeOff, Trash } from "lucide-react";
import Swal from 'sweetalert2'
import { useGlobalContext } from "./../../component/GlobalContext";
import Tippy from '@tippyjs/react';

function VendorAddressForm({ addressesMain, loadVendorAddresses, index }) {
  const navigate = useNavigate();
  // For Adress
  const [addressError, setAddressError] = useState("");
  const [cityError, setCityError] = useState("");
  const [stateError, setStateError] = useState("");
  const [postalcodeError, setPostalcodeError] = useState("");
  const [longitudeError, setLongitudeError] = useState("");
  const [latitudeError, setLatitudeError] = useState("");
  const [openTimeErrors, setOpenTimeErrors] = useState({});
  const [closeTimeErrors, setCloseTimeErrors] = useState({});
  const [cityList, setcityList] = useState([]);


  const [formData, setFormData] = useState({
    id: 0,
    address: "",
    city_id: "",
    state: "",
    postal_code: "",
    longitude: "",
    latitude: "",
    is_mon_open: true,
    mon_open_time: "",
    mon_close_time: "",
    is_tue_open: true,
    tue_open_time: "",
    tue_close_time: "",
    is_wed_open: true,
    wed_open_time: "",
    wed_close_time: "",
    is_thu_open: true,
    thu_open_time: "",
    thu_close_time: "",
    is_fri_open: true,
    fri_open_time: "",
    fri_close_time: "",
    is_sat_open: true,
    sat_open_time: "",
    sat_close_time: "",
    is_sun_open: true,
    sun_open_time: "",
    sun_close_time: "",
  });

  useEffect(() => {
    if (addressesMain) {
      setFormData((prevData) => ({
        ...prevData,
        id: addressesMain.id,
        address: addressesMain.address,
        city_id: addressesMain.city_id,
        state: addressesMain.state,
        postal_code: addressesMain.postal_code,
        longitude: addressesMain.longitude || null,
        latitude: addressesMain.latitude || null,
        is_mon_open: addressesMain.is_mon_open || false,
        mon_open_time: addressesMain.mon_open_time || "",
        mon_close_time: addressesMain.mon_close_time || "",
        is_tue_open: addressesMain.is_tue_open || false,
        tue_open_time: addressesMain.tue_open_time || "",
        tue_close_time: addressesMain.tue_close_time || "",
        is_wed_open: addressesMain.is_wed_open || false,
        wed_open_time: addressesMain.wed_open_time || "",
        wed_close_time: addressesMain.wed_close_time || "",
        is_thu_open: addressesMain.is_thu_open || false,
        thu_open_time: addressesMain.thu_open_time || "",
        thu_close_time: addressesMain.thu_close_time || "",
        is_fri_open: addressesMain.is_fri_open || false,
        fri_open_time: addressesMain.fri_open_time || "",
        fri_close_time: addressesMain.fri_close_time || "",
        is_sat_open: addressesMain.is_sat_open || false,
        sat_open_time: addressesMain.sat_open_time || "",
        sat_close_time: addressesMain.sat_close_time || "",
        is_sun_open: addressesMain.is_sun_open || false,
        sun_open_time: addressesMain.sun_open_time || "",
        sun_close_time: addressesMain.sun_close_time || "",
      }));
    }
  }, []);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevState) => {
      const updatedFormData = {
        ...prevState,
        [name]: type === "checkbox" ? checked : value,
      };

      if (updatedFormData.latitude && updatedFormData.longitude) {
        setLatitudeError("");
        setLongitudeError("");
      } else {
        if (name === "latitude" && value && !updatedFormData.longitude) {
          setLongitudeError("Longitude is required");
        } else if (name === "latitude") {
          setLongitudeError("");
        }

        if (name === "longitude" && value && !updatedFormData.latitude) {
          setLatitudeError("Latitude is required");
        } else if (name === "longitude") {
          setLatitudeError("");
        }
      }

      return updatedFormData;
    });
  };


  const handleRadioChange = (e) => {
    setFormData({ ...formData, same_address: e.target.value });
  };

  const resetForm = () => {
    setFormData((prevData) => ({
      ...prevData,
      id: 0,
      address: "",
      city_id: "",
      state: "",
      postal_code: "",
      longitude: "",
      latitude: "",
    }));
  };
  const resetValidationErrors = () => {
    // For Address
    setAddressError('');
    setCityError('');
    setStateError('');
    setPostalcodeError('');
    setLongitudeError('');
    setLatitudeError('');
    setOpenTimeErrors({});
    setCloseTimeErrors({});
  };
  const validateField = () => {
    resetValidationErrors();

    let checked = true;


    //For Address 

    if (formData.address === '') {
      setAddressError('Please enter address');
      if (checked) {
        checked = false;
      }
    } else if ((formData.address).length < 5) {
      setAddressError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if ((formData.address).length > 200) {
      setAddressError("Max character limit is 200");
      if (checked) {
        checked = false;
      }
    }

    if (formData.city_id === '') {
      setCityError('Please enter city');
      if (checked) {
        checked = false;
      }
    } else if ((formData.city_id).length > 100) {
      setCityError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    if (formData.state === '') {
      setStateError('Please enter state');
      if (checked) {
        checked = false;
      }
    } else if ((formData.state).length > 100) {
      setStateError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    if (formData.postal_code === '') {
      setPostalcodeError('Please enter postal code');
      if (checked) {
        checked = false;
      }
    } else if ((formData.postal_code).length < 5) {
      setPostalcodeError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if ((formData.postal_code).length > 100) {
      setPostalcodeError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    // const longitudeRegex = /^-?((1[0-7]\d(\.\d+)?)|(180(\.0+)?))$/;
    // const longitudeRegex = /^-?(180(\.0+)?|1[0-7]\d(\.\d+)?|[0-9]?\d(\.\d+)?)$/;

    // if (formData.longitude === '') {
    //   setLongitudeError('Please enter Longitude');
    //   if (checked) {
    //     checked = false;
    //   }
    // } else if (!longitudeRegex.test(formData.longitude)) {
    //   setLongitudeError("Invalid Longitude format. Must be between -180 and 180");
    //   if (checked) {
    //     checked = false;
    //   }
    // } else if ((formData.longitude).length > 100) {
    //   setLongitudeError("Max character limit is 100");
    //   if (checked) {
    //     checked = false;
    //   }
    // }

    // const latitudeRegex = /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/;
    // if (formData.latitude === '') {
    //   setLatitudeError('Please enter latitude');
    //   if (checked) {
    //     checked = false;
    //   }
    // } else if (!latitudeRegex.test(formData.latitude)) {
    //   setLatitudeError("Invalid Latitude format. Must be between -90 and 90");
    //   if (checked) {
    //     checked = false;
    //   }
    // } else if ((formData.latitude).length > 100) {
    //   setLatitudeError("Max character limit is 100");
    //   if (checked) {
    //     checked = false;
    //   }
    // }

    const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

    days.forEach((day) => {
      if (formData[`is_${day}_open`]) {
        const openTime = formData[`${day}_open_time`];
        const closeTime = formData[`${day}_close_time`];

        if (!openTime) {
          setOpenTimeErrors((prev) => ({
            ...prev,
            [day]: `Please select ${day} open time`,
          }));
          checked = false;
        }

        if (!closeTime) {
          setCloseTimeErrors((prev) => ({
            ...prev,
            [day]: `Please select ${day} close time`,
          }));
          checked = false;
        }

        if (openTime && closeTime && openTime >= closeTime) {
          setCloseTimeErrors((prev) => ({
            ...prev,
            [day]: `${day} close time must be later than open time`,
          }));
          checked = false;
        }
      }
    });

    return checked;
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const access_token = localStorage.getItem('access_token');
        const config = {
          headers: { "Content-Type": "application/json", token: access_token },
        };

        const response = await HTTP.post("vendors_address/city", config); // Adjust the URL to your backend endpoint

        if (response.status === 200) {
          setcityList(response.data); // Assume response.data contains the list of cities
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCityError("Failed to load cities.");
      }
    };

    fetchCities();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateField()) {
      try {
        const access_token = localStorage.getItem('access_token');
        let config = {
          headers: { "Content-Type": "application/json", token: access_token },
        };

        await HTTP.post(
          "/vendors_address/add",
          formData,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: response.data.message,
                //   text: "Please verify your email before login",
                icon: "success"
              });
              if (formData.id == "0") {
                resetForm();
              }
              loadVendorAddresses()
              //   setUsermailToVerify(email);
              //   navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            // setError(error);
            // setRerenderFlag(true);
            // loadAaMasterData();
            // resetValidationErrors();
          });

        // setIsLoading(false);
      } catch (error) {
        // setError(error);
        // setRerenderFlag(true);
        // setIsLoading(false);
      }
    }
  };
  const handleDelete = async (id) => {
    const access_token = localStorage.getItem("access_token");
    const config = {
      headers: { "Content-Type": "application/json", token: access_token },
    };
    try {
      const access_token = localStorage.getItem('access_token');
      let config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };

      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        await HTTP.delete(
          `vendors_address/delete/${id}`,
          config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: response.data.message,
                //   text: "Please verify your email before login",
                icon: "success"
              });
              if (formData.id == "0") {
                resetForm();
              }
              loadVendorAddresses()
              //   setUsermailToVerify(email);
              //   navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              //   setPasswordError(error.response.data.detail);
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            if (error.response.status === 422) {
              console.log(error.response)
              // alert('here')
              Swal.fire({
                title: 'Error!',
                text: error.response.data.detail[0].msg + " " + error.response.data.detail[0].input,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
          });
        // setIsLoading(false);
      }
    } catch (error) {
    }
  };


  return (
    <>

      <form className="space-y-4 mt-8" onSubmit={handleSubmit}>
        <div className="bg-white rounded-lg p-6 border-gray-200 border">
          <div className="flex item-center justify-between">
            <h3 className="font-medium text-lg mb-4">Address {index > 0 && <span> - {index}</span>}</h3>
            {formData.id ?
              <span onClick={() => handleDelete(formData.id)}>
                <Trash className='w-4 h-4 ' />
              </span> : ''
            }
          </div>
          <div className="grid grid-cols-2 gap-4">
            {/* Address */}
            <div className="space-y-2">
              <label htmlFor="address" className="text-sm font-medium">
                Address
              </label>
              <input
                type="text"
                id="address"
                name="address"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.address}
                onChange={handleChange}
              />
              {addressError && <span className="text-sm text-red-500">{addressError}</span>}
            </div>

            {/* City */}
            <div className="space-y-2">
              <label htmlFor="city_id" className="text-sm font-medium">
                City
              </label>
              <select
                name="city_id"
                value={formData.city_id}
                onChange={handleChange}
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
              >
                <option value="">Select City</option>
                {Array.isArray(cityList) && cityList.length > 0
                  ? cityList.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name} {/* Assuming city has 'id' and 'name' */}
                    </option>
                  ))
                  : <option value="">No cities available</option>}
              </select>
              {cityError && <span className="text-sm text-red-500">{cityError}</span>}
            </div>

            {/* State */}
            <div className="space-y-2">
              <label htmlFor="business_description" className="text-sm font-medium">
                State
              </label>
              <input
                type="text"
                id="state"
                name="state"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.state}
                onChange={handleChange}
              />
              {stateError && <span className="text-sm text-red-500">{stateError}</span>}
            </div>

            {/* Postal code */}
            <div className="space-y-2">
              <label htmlFor="postal_code" className="text-sm font-medium">
                Postal Code
              </label>
              <input
                type="text"
                id="postal_code"
                name="postal_code"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.postal_code}
                onChange={handleChange}
              />
              {postalcodeError && <span className="text-sm text-red-500">{postalcodeError}</span>}
            </div>

            {/* Latitude */}
            <div className="space-y-2">
              <label htmlFor="latitude" className="text-sm font-medium flex items-center">
                Latitude
                <Tippy
                  content={
                    <span>
                      To get your Longitude and Latitude:<br />
                      1. Copy your address.<br />
                      2. Go to <a href="https://www.gps-coordinates.net/" target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">Get Coordinates</a>.<br />
                      3. Paste it into the "Address" field.<br />
                      4. Click "Get GPS Coordinates".<br />
                      5. You will get your latitude and longitude.
                    </span>
                  }
                  placement="bottom"
                  interactive={true}
                >
                  <span className="ml-2 cursor-pointer text-gray-500">ℹ</span>
                </Tippy>
              </label>
              <input
                type="text"
                id="latitude"
                name="latitude"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.latitude}
                onChange={handleChange}
              />
              {latitudeError && <span className="text-sm text-red-500">{latitudeError}</span>}
            </div>

            {/* Longitude */}
            <div className="space-y-2">
              {/* <label htmlFor="longitude" className="text-sm font-medium">
                Longitude
              </label> */}
              <label htmlFor="latitude" className="text-sm font-medium flex items-center">
                Longitude
                <Tippy
                  content={
                    <span>
                      To get your Longitude and Latitude:<br />
                      1. Copy your address.<br />
                      2. Go to <a href="https://www.gps-coordinates.net/" target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">Get Coordinates</a>.<br />
                      3. Paste it into the "Address" field.<br />
                      4. Click "Get GPS Coordinates".<br />
                      5. You will get your latitude and longitude.
                    </span>
                  }
                  placement="bottom"
                  interactive={true}
                >
                  <span className="ml-2 cursor-pointer text-gray-500">ℹ</span>
                </Tippy>
              </label>
              <input
                type="text"
                id="longitude"
                name="longitude"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.longitude}
                onChange={handleChange}
              />
              {longitudeError && <span className="text-sm text-red-500">{longitudeError}</span>}
            </div>

            {/* Weekly schedule */}
            {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map((day) => (
              <div className="col-span-2 grid grid-cols-3 gap-4 items-center" key={day}>
                <div className="space-y-2">
                  <label className="admin-table-toggle-switch">
                    <input
                      type="checkbox"
                      name={`is_${day}_open`}
                      checked={formData[`is_${day}_open`]}
                      onChange={handleChange}
                      className="admin-table-toggle-input"
                    />
                    <span
                      className={`admin-table-slider ${formData[`is_${day}_open`] ? "admin-table-slider-checked" : ""}`}
                    >
                      <span
                        className={`admin-table-slider-before ${formData[`is_${day}_open`] ? "admin-table-slider-checked-before" : ""}`}
                      ></span>
                    </span>
                  </label>
                  <label className="text-sm font-medium">&nbsp;&nbsp;{day.charAt(0).toUpperCase() + day.slice(1)}</label>
                  {/* <label className="text-sm font-medium">{day} Open</label> */}
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-medium">Open Time</label>
                  <input
                    type="time"
                    name={`${day}_open_time`}
                    value={formData[`${day}_open_time`]}
                    onChange={handleChange}
                    className="input"
                    disabled={!formData[`is_${day}_open`]}
                  />
                  {openTimeErrors[day] && (<span className="text-sm text-red-500">{openTimeErrors[day]}</span>)}
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-medium">Close Time</label>
                  <input
                    type="time"
                    name={`${day}_close_time`}
                    value={formData[`${day}_close_time`]}
                    onChange={handleChange}
                    className="input"
                    disabled={!formData[`is_${day}_open`]}
                  />
                  {closeTimeErrors[day] && (<span className="text-sm text-red-500">{closeTimeErrors[day]}</span>)}
                </div>
              </div>
            ))}

          </div>
          <div>&nbsp;</div>

          <button
            type="submit"
            className="theme-button text-white px-4 py-2 rounded-md shadow-sm"
          >
            {formData.id ? "Update" : "Submit"}
          </button>
        </div>

      </form>
    </>
  )
}

export default VendorAddressForm